"use strict";
// Copyright © Veeam Software Group GmbH.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorage = void 0;
class SessionStorage {
    constructor(key, errorHandler, initialValue) {
        this.key = key;
        this.errorHandler = errorHandler;
        if (initialValue) {
            this.setValue(initialValue);
        }
    }
    onCatchError(err) {
        if (this.errorHandler) {
            this.errorHandler(err);
        }
        else {
            console.error(err);
        }
    }
    getValue() {
        const rawValue = sessionStorage.getItem(this.key);
        if (rawValue === null) {
            return null;
        }
        try {
            // ToDo: insert runtime type checking & validation
            return JSON.parse(rawValue);
        }
        catch (err) {
            this.onCatchError(err);
            return null;
        }
    }
    setValue(value) {
        try {
            const rawValue = JSON.stringify(value);
            sessionStorage.setItem(this.key, rawValue);
        }
        catch (err) {
            this.onCatchError(err);
        }
    }
    clear() {
        sessionStorage.removeItem(this.key);
    }
}
exports.SessionStorage = SessionStorage;
//# sourceMappingURL=SessionStorage.js.map